import qs from 'qs'
import { HTTP } from './helpers/http.js'

export default {
  getOrganizationStream(organizationId, query) {
    query.filters = { ...query.filters }
    const params = {
      params: query,
      paramsSerializer: function(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/stream/${organizationId}/revs`
    return HTTP.get(url, params)
  },
}
